import { InvoicesResponse } from '@commenda/types/src/root-fi/types';
import { SWRFetcher, serializeRootFiInvoicesData } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export default function useInvoices(rootFiCompanyId: number, token: string) {
  const {
    data,
    error,
    mutate,
  }: {
    mutate: KeyedMutator<unknown>;
    error: unknown;
    data: { invoices: InvoicesResponse };
  } = useSWR(
    `rootFi/invoices/${rootFiCompanyId}`,
    SWRFetcher({ method: 'GET' }, token)
  );

  const serializedInvoices = serializeRootFiInvoicesData(data?.invoices);

  return {
    data: serializedInvoices,
    error,
    mutate,
  };
}
